import leven from 'leven'

import { emailRegex } from './validation'

export enum EmailDomain {
  Gmail = 'gmail.com',
  Yahoo = 'yahoo.com',
  Hotmail = 'hotmail.com',
  Outlook = 'outlook.com',
  ICloud = 'icloud.com',
  AOL = 'aol.com',
  Live = 'live.com',
  MSN = 'msn.com',
  GoogleMail = 'googlemail.com',
  YahooUK = 'yahoo.co.uk',
  Marshmallow = 'marshmallow.co',
  HotmailUK = 'hotmail.co.uk',
  Me = 'me.com',
  Mac = 'mac.com',
  ProtonMail = 'protonmail.com',
}

export const popularEmailDomains: EmailDomain[] = Object.values(EmailDomain)

const findClosestDomain = (domain: string, domainList: string[]) => {
  let closestDomain = null
  let minDistance = Infinity

  for (const popularDomain of domainList) {
    const distance = leven(domain, popularDomain)
    if (distance < minDistance) {
      minDistance = distance
      closestDomain = popularDomain
    }
  }

  // after checking all domains, return the closest domain if the minimum distance is less than or equal to 1
  // this allows only very close matches (e.g., one character difference)
  return minDistance <= 1 ? closestDomain : null
}

export const validateEmail = (value: string | undefined | null) => {
  // We don't validate for optional value inside this validation,
  // `.required()` should be added additionally if necessary
  if (typeof value !== 'string' || value.trim() === '') {
    return { isValid: true, message: null }
  }

  if (!emailRegex.test(value)) {
    return { isValid: false, message: "We don't recognise that email format!" }
  }

  const domain = value.split('@')[1]
  if (domain) {
    const closestDomain = findClosestDomain(domain, popularEmailDomains)
    if (closestDomain && closestDomain !== domain) {
      return {
        isValid: true,
        warning: true,
        message: `Did you mean "${value.split('@')[0]}@${closestDomain}"?`,
      }
    }
  }

  return { isValid: true, message: null }
}
